import validateTimes from 'utils/dateAndTimes/validators/validateTimes';
import asyncValidateTimes from 'utils/dateAndTimes/validators/asyncValidateTimes';
import validateTime from 'utils/dateAndTimes/validators/validateTime';
import getRules from 'utils/dateAndTimes/validators/getRules';
import getRulesWithRestrictions from 'utils/dateAndTimes/validators/getRulesWithRestrictions';
import priorityRules from 'utils/dateAndTimes/validators/priorityRules';

export default {
  validateTimes,
  asyncValidateTimes,
  validateTime,
  getRules,
  getRulesWithRestrictions,
  priorityRules,
};
